import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AppConfig } from 'src/app/app-config';

export function redirectGuard(redirectToOldCMS: boolean): CanActivateFn {
  return (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
    const appConfig: AppConfig = inject(AppConfig);
    let redirectUrl = '';
    if (redirectToOldCMS) {
      redirectUrl = appConfig.cmsUrl;
    }
    redirectUrl =
      redirectUrl + document.location.pathname.replace('/cms/', '/');
    document.location.href = redirectUrl;
    return of(false);
  };
}
